<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
            <b-form @submit.prevent="handleSubmit(saveAttributeData)">  
                <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                    <template v-slot:header>
                        <p class="mb-0" style="font-size: 21px">Actualizar Atributo</p>
                    </template>
                    <b-card-text>
                        <b-alert show variant="danger" v-if="errors">
                            <ul >
                                <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                            </ul>
                        </b-alert>
                        <b-row>        
                            <b-col cols="12" md="6">
                                <ValidationProvider name="codigo" rules="required|min:1" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Código:">
                                        <b-form-input
                                            v-model="saveData.codigo"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el código"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Nombre:">
                                        <b-form-input
                                            v-model="saveData.nombre"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el nombre"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="tipo"  rules="required" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Selecciona tipo:"
                                        label-for="tipo">
                                        
                                        <b-form-select
                                            v-model="saveData.tipo"
                                            :options="tipo"
                                            class="mb-3"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                        </b-form-select>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group 
                                    label="Estado:"
                                    label-for="status">
                                    <b-row cl>
                                    <b-form-checkbox v-model="saveData.status" name="status" switch class="ml-3" />
                                    <span v-if="saveData.status === true">Activo</span>
                                    <span v-else>Inactivo</span>
                                    </b-row>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-text>
                    <template v-slot:footer>
                        <b-button variant="danger" class="mr-2" @click.prevent="back">
                            Cancelar
                        </b-button>
                        <b-button variant="success" :disabled="invalid" type="submit">
                            Actualizar
                        </b-button>
                    </template>
                </b-card>
            </b-form>
        </ValidationObserver>

        <ValidationObserver ref="userInfo" v-slot="{ handleSubmit, invalid }">
            <b-form @submit.prevent="handleSubmit(saveAttributeValueData)">  
                <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                    <template v-slot:header>
                        <p class="mb-0" style="font-size: 21px">Posibles Valores</p>
                    </template>
                    <b-card-text>
                        <b-row>        
                            <b-col cols="12" md="4">
                                <ValidationProvider name="valor" rules="required|min:1" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Nombre valor atributo:">
                                        <b-form-input
                                            v-model="valor"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el código"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card-text>
                    <template v-slot:footer>
                        <b-button variant="success" :disabled="invalid" type="submit">
                            Agregar
                        </b-button>
                    </template>
                </b-card>
            </b-form>
        </ValidationObserver>
        
        <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
            <template v-slot:header>
                <p class="mb-0" style="font-size: 21px">Valores Agregados</p>
            </template>
            <b-card-text>
                <b-alert show variant="danger" v-if="errorsAttributesValues">
                    <ul >
                        <li v-for="(item, index) in errorsAttributesValues" :key="index">{{ item }}</li>
                    </ul>
                </b-alert>
                <b-row>        
                    <b-col cols="12" md="4" v-for="(item, index) in atributosValores" :key="index">
                        <b-form inline
                            label="Nombre valor atributo:">
                            <b-form-input
                                v-model="item.valor"
                                type="text"
                                autocomplete="off"
                                required
                                placeholder="Ingrese el nombre"
                                @change="updateAttributeValueData(item)"
                                ></b-form-input>
                                <b-button variant="danger" v-b-tooltip.hover title="Inactivo" v-if="item.status == false" @click.prevent="updateAttributeValueStatus(item)">X</b-button>
                                <b-button variant="success" v-else @click.prevent="updateAttributeValueStatus(item)">
                                    <b-icon icon="check"></b-icon>
                                </b-button>
                        </b-form>
                    </b-col>
                    
                </b-row>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            errors: "",
            saveData: {},
            tipo: [
                { text: 'Seleccion', value: 'Seleccion' },
                { text: 'Libre', value: 'Libre' },
            ],
            atributosValores: [],
            valor: "",
            errorsAttributesValues: "",
        }
    },
    created(){
        this.getAttributeData();
        this.getAttributeValuesList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getAttributeValuesList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/attributes/values/get-attribute-values-list', {id: this.$route.params.id})
            .then(response =>{
                this.atributosValores = response.data.atributosValoresList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getAttributeData(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/attributes/get-attribute-data', {id: this.$route.params.id})
            .then(response =>{
                this.saveData = response.data.attributeData;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async saveAttributeData(){
            this.setLoading(true)
            this.errors = "";
            await this.$conectar.post('/empresa/attributes/save-attribute', this.saveData)
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error == false){
                    this.$bvToast.toast('Se guardo correctamente el atributo', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }
                
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async saveAttributeValueData(){
            this.setLoading(true)
            this.errorsAttributesValues = "",
            await this.$conectar.post('/empresa/attributes/values/save-attribute-value', {atributo_id: this.$route.params.id, valor: this.valor})
            .then(response =>{
                if(response.data.errors){
                    this.errorsAttributesValues = response.data.errors;
                }
                if(response.data.error == false){
                    this.getAttributeValuesList();
                    this.valor = "";
                    this.$bvToast.toast('Se guardo correctamente el posible valor', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async updateAttributeValueData(item){
            this.setLoading(true)
            this.errorsAttributesValues = "",
            await this.$conectar.post('/empresa/attributes/values/save-attribute-value', {id: item.id, atributo_id: this.$route.params.id, valor: item.valor})
            .then(response =>{
                if(response.data.errors){
                    this.errorsAttributesValues = response.data.errors;
                }
                if(response.data.error == false){
                    this.getAttributeValuesList();
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async updateAttributeValueStatus(item){
            this.setLoading(true)
            this.errorsAttributesValues = "";
            item.status = !item.status
            await this.$conectar.post('/empresa/attributes/values/update-attribute-value-status',
                                     {id: item.id,
                                      atributo_id: this.$route.params.id,
                                      status: item.status})
            .then(response =>{
                if(response.data.errors){
                    item.status = !item.status
                    this.errorsAttributesValues = response.data.errors;
                }
                if(response.data.error == false){
                    this.$bvToast.toast('Se actualizo el estado del posible valor', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.getAttributeValuesList();
                }
            })
            .catch(e => {
                console.log(e.response);
                item.status = !item.status
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        }
    }
}
</script>